import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendAdminViewSampleWithInstanceAndSpec,
	FrontendSampleTestInformation,
} from "node-library/dist/portal";

import {
	ONE_DAY_IN_MS,
	TestStatus,
	SystemRole,
} from "node-library/dist/constants";

import { NeutralColor, SemanticColor } from "node-library/dist/colors";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import {
	getTestStatusColors,
	getTestStatusTranslationText,
} from "../../../helpers/sampleInstanceHelper";
import { OrderIcon, UserIcon } from "../../../common-components/svgIcons";
import {
	getShortTurnaroundTime,
	getTurnaroundTimeBackgroundColor,
} from "../../../helpers/sampleHelper";

interface Props {
	instance: FrontendAdminViewSampleWithInstanceAndSpec;
	user: FrontendUserInfo | undefined;
	goToViewOrderDetails: () => void;
	goToViewInstanceDetails: () => void;
}

export default function AdminViewInstanceRow(props: Props) {
	const { t: translation } = useTranslation();

	const { instance, goToViewOrderDetails, user, goToViewInstanceDetails } =
		props;

	const sampleTestInfo =
		instance.sampleTestInfo as FrontendSampleTestInformation;
	const statusString: string = getTestStatusTranslationText(
		sampleTestInfo.status as TestStatus,
		translation
	);
	const statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	} = getTestStatusColors(sampleTestInfo.status as TestStatus);

	//currently only used for admin view - submitted orders so always have the date
	const currDate: Date = new Date();
	const dueDate: Date = new Date(instance.expectedCompletionTime as Date);
	const dueDateString: string = formatCustomDate(dueDate);

	const remainingTimeInMillis =
		dueDate.getTime() - currDate.getTime() - ONE_DAY_IN_MS;
	const dueDateWarning: boolean = remainingTimeInMillis <= 0;

	const TATBackgroundColor: string = getTurnaroundTimeBackgroundColor(
		sampleTestInfo.turnaroundTime
	);

	const orderRowItem: React.ReactNode = (
		<div
			key={instance.sampleInstanceId}
			className="instance-list-view-row instance-list-view-item-row typography-body-01"
			onClick={() => {
				goToViewInstanceDetails();
			}}
		>
			<div
				className={`${
					dueDateWarning ? `typography-bold` : ``
				} instance-list-view-row-id-section instance-list-view-row-item`}
			>
				{dueDateWarning && (
					<span
						style={{
							width: "8px",
							height: "8px",
							borderRadius: "50%",
							backgroundColor: SemanticColor.ERROR,
						}}
					></span>
				)}
				{instance.sample.fullSampleId}
				<div
					className="typography-caption turnaround-time-box"
					style={{ backgroundColor: TATBackgroundColor }}
				>
					{getShortTurnaroundTime(sampleTestInfo.turnaroundTime, translation)}
				</div>
				{instance.isRetest ? (
					<div
						className="typography-caption turnaround-time-box"
						style={{ backgroundColor: TATBackgroundColor }}
					>
						{translation("Retest")}
					</div>
				) : (
					<></>
				)}
				{instance.isAdditionalTest ? (
					<div
						className="typography-caption turnaround-time-box"
						style={{ backgroundColor: TATBackgroundColor }}
					>
						{translation("Add")}
					</div>
				) : (
					<></>
				)}
			</div>
			<div className="instance-list-view-row-item">{instance.barcodeId}</div>
			<div className="instance-list-view-row-item">
				{instance.clientCompanyName}
				<div
					className="typography-caption"
					style={{
						display: "flex",
						gap: "5px",
						flexWrap: "wrap",
						color: NeutralColor.NEUTRAL_GREY_500,
					}}
				>
					{/* <div style={{ display: "flex", gap: "3px", alignItems: "end" }}>
						<UserIcon
							size={20}
							strokeColor={NeutralColor.NEUTRAL_GREY_500}
							strokeWidth={1.5}
						/>
						{order.orderedBy}
					</div> */}
				</div>
			</div>
			<div className="instance-list-view-row-item">
				{dueDateString.split(" | ")[0]}
			</div>
			<div className="instance-list-view-row-item">
				<div
					className="typography-caption admin-sample-status-box admin-status-box-medium"
					style={{
						backgroundColor: statusColor.backgroundColor,
						border: `1px solid ${statusColor.borderColor}`,
						color: statusColor.textColor,
					}}
				>
					{statusString}
				</div>
			</div>
			<div className="instance-list-view-row-item">
				<div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
					<div
						id={`view-order-${instance.sampleInstanceId}`}
						style={{ cursor: "pointer" }}
						onClick={(e) => {
							e.stopPropagation();
							goToViewOrderDetails();
						}}
					>
						<OrderIcon size={20}></OrderIcon>
					</div>
				</div>
			</div>
		</div>
	);

	return orderRowItem;
}
